// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2aUTV","subheader":"ReorderModal_subheader__3V3B-","listWrap":"ReorderModal_listWrap__31nd_"};